<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('quotes.create')" @invoke-method="invokeMethod($event)" action="openQuoteForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetQuotes(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status_id"
                                            :placeholder="$t('lang.status_id')"
                                            :items="quote_status"
                                            item-value="option_id"
                                            item-text="option"
                                            prepend-icon="monitor_heart"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="quotes" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openQuoteForm(props.item)">
                                <td>{{ props.item.quote_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td class="text-center">{{ props.item.quoted_by }}</td>
                                <td class="text-center">{{ props.item.quote_date }}</td>
                                <td>${{ props.item.total_amount }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="quotes"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="quote_dialog">
                <v-card>
                    <v-form ref="form_quote">
                        <v-card-title>
                            <span class="headline">{{ quote.quote_id ? $t("lang.edit_quote") : $t("lang.add_quote") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeQuoteDialog"
                                :dialog-status="quote_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="quote.company_id"
                                            :label="`${$t('lang.company_id')} *`"
                                            :items="customers"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('quotes.company_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="quote.quote_id" color="error" @mouseup.left="$refs.delete_quotes.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeQuoteDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveQuotes">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_quotes"
                :heading="$t('lang.delete_quote')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteQuotes(quote.quote_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openQuoteForm" },
                { title: this.$t("lang.refresh"), action: "dbGetQuotes", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.quote_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "40%" },
                { text: this.$t("lang.quoted_by_id"), sortable: false, align: "center", width: "20%" },
                { text: this.$t("lang.quote_date"), sortable: false, align: "center", width: "10%" },
                { text: this.$t("lang.total_amount"), sortable: false, width: "10%" },
                { text: this.$t("lang.status"), sortable: false, align: "center", width: "10%" },
            ],
            enableAddModal: false,
            enableEditModal: false,
            customers: null,
            quote: {},
            filter: {
                search: "",
                status_id: "",
                company_id: "",
            },
            quote_dialog: false,
            dbGetQuotes: _.debounce(this.getQuotes, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchQuotes", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.quotes) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchQuotes({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.quotes) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetQuotes");
        this.$store.commit("resetOptions");
        next();
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.quotes.quotes_filter,
            page: (state) => state.quotes.page,
            rules_quotes: (state) => state.quotes.rules_quotes,
            quote_status: (state) => state.options_categories.quote_status,
            quotes: (state) => state.quotes.quotes,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchQuotes", "saveQuote", "deleteQuote", "fetchFeParts", "fetchOptions", "fetchCustomers"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openQuoteForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    //if (this.customer_options.length == 0)
                    this.fetchCustomers({ body: { options: 1 } });

                    if (this.$refs.form_quote) item ? this.$refs.form_quote.resetValidation() : this.$refs.form_quote.reset();

                    this.$nextTick(() => {
                        this.quote = item != null ? this.assignObj2(item, this.rules_quotes) : {};
                        this.quote_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "quote", params: { id: item.quote_id } });
                }
            } else {
                if (this.enableAddModal) {
                    //if (this.customer_options.length == 0)
                    this.fetchCustomers({ body: { options: 1 } });

                    if (this.$refs.form_quote) item ? this.$refs.form_quote.resetValidation() : this.$refs.form_quote.reset();
                    this.quote_dialog = true;
                } else {
                    this.$router.push({ name: "quote" });
                }
            }
        },
        saveQuotes() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_quote")) {
                    let body = this.prepForm(this.quote, this.rules_quotes);

                    this.saveQuote({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getQuotes();
                                this.closeQuoteDialog();
                            } else {
                                this.$router.push({ name: "quote", params: { id: data.quote.quote_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteQuotes(id = null) {
            this.deleteQuote({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getQuotes();
                    this.closeQuoteDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeQuoteDialog() {
            this.quote_dialog = false;
            this.$refs.delete_quotes.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getQuotes(pg_refresh = false) {
            this.startLoader();

            this.fetchQuotes({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.quote_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.quote_status == 0 || force == true) await this.fetchOptions({ body: { slug: "quote_status", options: 1 } });

            //if (this.customer_options.length == 0 || force == true)

            this.finishLoader();
        },
    },
};
</script>
